import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { inject, observer } from "mobx-react";
import React from "react";
import { Button, Form, Table } from "react-bootstrap";
import { RouteComponentProps } from "react-router-dom";
import { SelectCustomerModal } from "../../components/SelectCustomerModal";
import { STORE_CUSTOMERS, STORE_CUSTOMER_ORDERS, STORE_USERS } from "../../constants";
import { Customer, CustomersStore, UsersStore } from "../../stores";
import { CustomerOrdersStore } from "../../stores/CustomerOrdersStore";
interface IProps {
    history: any,
    [STORE_CUSTOMER_ORDERS]: CustomerOrdersStore
    [STORE_CUSTOMERS]: CustomersStore
    [STORE_USERS]: UsersStore
}

export interface BindedUser {
    abtId: string,
    asId: string,
    asName: string,
}

interface IState {
    selectModalOpenedId: string,
    bindedUsers: BindedUser[],
}
type Props = IProps & RouteComponentProps<{ page: string }>;

@inject(STORE_CUSTOMER_ORDERS, STORE_CUSTOMERS, STORE_USERS)
@observer
export class AbtekaToAsUserPage extends React.Component<Props, IState> {

    customersStore = (this.props as any)[STORE_CUSTOMERS] as CustomersStore;
    usersStore = (this.props as any)[STORE_USERS] as UsersStore;
    customerOrdersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;


    constructor(props: Props) {
        super(props);
        this.state = {
            selectModalOpenedId: "",
            bindedUsers: [],
        };
    }


    componentDidMount() {

        this.usersStore.loadBindedUsers(() => this.setState({
            bindedUsers: this.usersStore.bindedUsers,
        }));
        this.usersStore.loadUsers();
    }

    private openSelectAsModal = (id: string) => {
        this.setState({ selectModalOpenedId: id });
    }

    private saveFilterToLocalStorage = () => {
        localStorage.setItem("asUserFilter", JSON.stringify({
            bindedUsers: this.state.bindedUsers
        }));
    }

    private bindAsToAbteka = () => {
        this.usersStore.bindAsUser(this.state.bindedUsers);
        return;
    }

    render() {

        return [
            <Form key="User">
                <Table style={{width:"95%"}}>
                    <thead>
                        <tr>
                            <th style={{ width: "47%" }}>Пользователь BO</th><th style={{ width: "47%" }}>Привязка автосюза</th><th style={{ width: "6%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.usersStore.users.map((user, i) => {
                            return <tr key={"u-" + i.toString()}>
                                <td>{user.userFio}</td>
                                <td>
                                        <div className="form-inline" style={{
                                            border: "1px solid #d8d8d8",
                                            borderRadius: "3px",
                                            padding: "0px 2px",
                                            fontSize: "11pt",
                                            cursor: "pointer"                                            
                                        }}
                                            onClick={() => { this.openSelectAsModal(user.userId) }}>
                                            <div style={{ width: "100%", marginLeft: "-40px", paddingLeft: "40px" }}>
                                                {this.state.bindedUsers.some((x) => x.abtId == user.userId) ?
                                                    <span>{this.state.bindedUsers.find((x) => x.abtId == user.userId)?.asName}</span> :
                                                    <span>Не выбрано</span>}

                                            </div>
                                            {this.state.selectModalOpenedId == "" ? [] :
                                                <Button type="button" variant="link" size="sm" style={{ marginLeft: "-3px", marginRight: "-12px" }}
                                                    onClick={(e: any) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        this.setState({}, () => {
                                                            this.saveFilterToLocalStorage()
                                                        });
                                                    }}>
                                                    <FontAwesomeIcon icon="times" style={{ color: "black" }} />
                                                </Button>
                                            }
                                        </div>
                                </td>
                                <td>{this.state.bindedUsers.some((x) => x.abtId == user.userId) ? 
                                    <Button type="button" size="sm" style={{ marginLeft: "-3px", marginRight: "-12px", backgroundColor: "red", borderColor: "red" }}
                                    onClick={() => {
                                        const saved = this.state.bindedUsers.filter((x) => x.abtId != user.userId);
                                        this.setState({
                                            bindedUsers: saved,
                                            selectModalOpenedId: "",
                                        });
                                    }}>
                                    <FontAwesomeIcon icon="xmark" style={{ color: "white" }} />
                                </Button> : []}</td>

                                <SelectCustomerModal
                                    key={i.toString()}
                                    customersStore={this.customersStore}
                                    isOpened={this.state.selectModalOpenedId == user.userId}
                                    source={"as"}
                                    title={"Учетки автосоюза"}
                                    onCustomerSelected={(customer: Customer) => {
                                        const saved = this.state.bindedUsers.filter((x) => x.abtId != user.userId)
                                        this.setState({
                                            bindedUsers: [...saved, { abtId: user.userId, asId: customer.id, asName: customer.friendlyName } as BindedUser],
                                            selectModalOpenedId: "",
                                        }, () => {
                                            this.saveFilterToLocalStorage()
                                        });
                                    }}
                                    openNewCustomerModal={() => { }}
                                    onHideHandler={() => { this.setState({ selectModalOpenedId: "" }) }}
                                />
                            </tr>
                        })}
                    </tbody>
                </Table>

            </Form>,

            <Button key='bind'
                onClick={this.bindAsToAbteka}>
                <FontAwesomeIcon icon="save" style={{ color: "black" }} />
            </Button>
        ]
    }
}